export default "__VITE_ASSET__4bde13c5__"